import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';

export default (_t, { model_app }) => {
  const btn_list: BtnListConfig = [
    {
      name: '修改',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '修改视图',
        component: 'dbViewConfig',
        init_data: {
          form_type: 'edit',
          model_app: model_app,
        },
      },
      authority: `${model_app}/update_db_view`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
  ];
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '新建SQL视图',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '新建SQL视图',
        component: 'dbViewConfig',
        init_data: {
          form_type: 'create',
          model_app: model_app,
        },
      },
      authority: `${model_app}/create_db_view`,
    },
  ];
  return {
    head_btn_list: head_btn_list,
    btn_list: btn_list,
    is_operation: [false, false, true, true],
  };
};
